module.exports = __webpack_public_path__ + "static/media/ico_simulation_eye_brow.064f5ad2.png";